module.exports = __webpack_public_path__ + "img/40f6863.jpg";